export default {
      id: "tax-savings-usage",
      viewBox: "0 0 200 60",
      url: __webpack_public_path__ + "sprite.svg#tax-savings",
      toString: function () {
        return this.url;
      }
    }